import { BoxProps, Checkbox, HStack, Text } from "@chakra-ui/react";

interface CheckAgreementProps extends BoxProps {
  onCheck?: (checked: boolean) => void;
  isChecked?: boolean;
}

const CheckAgreement = (props: CheckAgreementProps) => {
  const { children, isChecked, onCheck, ...xprops } = props;
  return (
    <HStack {...xprops}>
      <Checkbox
        size="lg"
        isChecked={isChecked}
        onChange={(e) => !!onCheck && onCheck(e.target.checked)}
        borderColor="#2B3F6C"
        sx={{
          ".chakra-checkbox__control": {
            borderRadius: "6px",
            mr: "4px",
          },

          ".chakra-checkbox__control[aria-checked=true],.chakra-checkbox__control[data-checked]": {
            bg: "secondary.default",
            borderColor: "secondary.default",
          },
          ".chakra-checkbox__control[aria-checked=true]:hover,.chakra-checkbox__control[data-checked]:hover": {
            bg: "secondary.default",
            borderColor: "secondary.default",
          },
        }}
      >
        <Text fontSize="sm" fontWeight="500">
          {children}
        </Text>
      </Checkbox>
    </HStack>
  );
};

export default CheckAgreement;
